// SessionData/RouteData allow `null` (to support in-place edits, which can
// clear a field), but the underlying create endpoints only accept the
// create-shape (`| undefined`, no `null`). Normalize before calling them.
export function withoutNulls<T extends object>(data: T): { [K in keyof T]: Exclude<T[K], null> } {
  const result = {} as Record<string, unknown>;
  for (const [key, value] of Object.entries(data)) {
    result[key] = value === null ? undefined : value;
  }
  return result as { [K in keyof T]: Exclude<T[K], null> };
}
